import { createSlice } from '@reduxjs/toolkit'
import asyncLogin from '../thunks/auth/asyncLogin';
import asyncLoginWithRefresh from '../thunks/auth/asyncLoginWithRefresh';
import asyncLogout from '../thunks/auth/asyncLogout';
import asyncRefresh from '../thunks/auth/asyncRefresh';

const initialState = {
    isAuth: false,
    error: null
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setIsAuth(state, action) {
            state.isAuth = action.payload
        }
    },
    extraReducers: builder => {
        // Async try login with refresh
        builder.addCase(asyncLoginWithRefresh.fulfilled, (state, action) => {
            state.isAuth = action.payload?.isAuth ?? false;
        })
        // Async login
        builder.addCase(asyncLogin.fulfilled, (state, action) => {
            const {payload} = action;

            if (!Object.keys(payload).length) return;

            const success = payload.success;

            if (success) {
                const {tokens} = payload.data;

                sessionStorage.access = tokens.access;
                localStorage.refresh = tokens.refresh;
    
                state.isAuth = true;
                state.error = null;
                return;
            } 
            
            const {errors} = payload;
            
            state.error = errors?.login || errors?.password;

            state.error = "Приозошла непредвиденная ошибка входа!"
        });
        builder.addCase(asyncLogin.rejected, (state, action) => {
            state.error = "Произошла непредвиденная ошибка!";
        });
        // Async logout
        builder.addCase(asyncLogout.fulfilled, (state, action) => {
            state.isAuth = false;
            state.error = null
        });
        // Async Refresh Token
        builder.addCase(asyncRefresh.fulfilled, (state, action) => {
            const {payload} = action;
            const success = payload.success;

            if (success) {
                const {tokens} = payload.data;
    
                sessionStorage.access = tokens.access;
                localStorage.refresh = tokens.refresh;

                state.isAuth = true;
                state.error = null;
                return;
            }

            localStorage.clear();
            sessionStorage.clear();
        });
        builder.addCase(asyncRefresh.rejected, (state, action) => {
            state.isAuth = false;
            localStorage.clear();
            sessionStorage.clear();
        })
    }
});

export const { setToken, setIsAuth } = authSlice.actions;
export default authSlice.reducer;